import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
	mode: "history",
	routes: [
		{
			path: "/",
			component: () => import("@/views/layout/layout"),
			redirect: "/dashboard/home",
			children: [
				{
					// 我的工单-保养任务
					path: "/myticket/maint",
					component: () => import("@/views/ticketmy/maint"),
				},
				{
					// 我的工单-报警处理
					path: "/myticket/alarm",
					component: () => import("@/views/ticketmy/alarm"),
				},
				{
					// 工单管理-保养任务
					path: "/ticket/maint",
					component: () => import("@/views/ticketmaint"),
				},
				{
					// 工单管理-设备保养任务
					name: "ticket-maint-item",
					path: "/ticket/maint/item",
					component: () => import("@/views/ticketmaint/maint-item"),
					props: true,
				},
				{
					// 工单管理-报警处理
					path: "/ticket/alarm",
					component: () => import("@/views/ticketalarm"),
				},
				/*{
                    // 设备管理-设备列表
                    path: '/devices',
                    component: () => import('@/views/devices')
                },*/
				{
					// 设备管理-耗材管理
					path: "/system/consumable",
					component: () => import("@/views/consumable/consumable"),
				},
				{
					// 采集器设置
					path: "/system/collector",
					component: () => import("@/views/collector/collector"),
				},
				{
					// 设备设置
					path: "/system/device",
					component: () => import("@/views/settingdevice/device"),
				},
				{
					// 设备因子
					name: "device-factor",
					path: "/system/device/factor",
					component: () =>
						import("@/views/settingdevice/device-factor"),
					props: true,
				},
				{
					// 保养标准
					path: "/system/maintstd",
					component: () => import("@/views/maintstd/maint-std"),
					props: true,
				},
				{
					// 标准内容
					name: "maint-std-content",
					path: "/system/maintstd/content",
					component: () => import("@/views/maintstd/mstd-content"),
					props: true,
				},
				{
					// 报警配置
					name: "maint-std-alarm",
					path: "/system/maintstd/alarm",
					component: () => import("@/views/maintstd/alarm"),
					props: true,
				},
				{
					// 组织架构
					path: "/system/org",
					component: () => import("@/views/org/org"),
					props: true,
				},
				{
					// 用户管理
					path: "/system/user",
					component: () => import("@/views/system/user/index"),
					props: true,
				},
				{
					// JOB管理
					path: "/system/job",
					component: () => import("@/views/system/job/index"),
					props: true,
				},
				{
					// 角色管理
					path: "/system/role",
					component: () => import("@/views/role/index"),
					props: true,
				},
				{
					// 字典
					path: "/system/dic",
					component: () => import("@/views/dic/dic"),
				},
				{
					// 客户管理
					path: "/customer",
					// component: () => import('@/views/customer/customer-new'),
					component: () => import("@/views/customer/customer_v1"),
				},
				{
					// 客户详情
					path: "/customer/detail/:id",
					component: () =>
						import("@/views/customer/customer-detail.vue"),
				},
				{
					// 客户tab页信息
					path: "/customer/index/:id/:tab",
					component: () => import("@/views/customer/tabpanel.vue"),
				},
				{
					// 设备保养手册
					name: "maint-doc",
					path: "/customer/maintstd/doc",
					component: () => import("@/views/customer/index/maint-doc"),
					props: true,
				},
				{
					// 提醒管理
					path: "/remind",
					component: () => import("@/views/remind/remind"),
				},
				{
					// 系统设置
					path: "/systemsetting",
					component: () =>
						import("@/views/systemsetting/systemsetting"),
				},
				{
					// 报修管理
					path: "/repair/record",
					component: () => import("@/views/repair/Record"),
				},
			],
		},
		// {
		//     path: '/dashboard',
		//     component: () => import('@/views/dashboard/layout'),
		//     children: [
		//         {
		//             // 设备详情
		//             name: 'device-detail',
		//             path: '/dashboard/device/:id',
		//             component: () => import('@/views/dashboard/device'),
		//         },
		//         {
		//             // 首页
		//             name: 'home',
		//             path: '/dashboard/home',
		//             component: () => import('@/views/dashboard/home'),
		//         }
		//     ]
		// },
		{
			path: "/dashboard",
			component: () => import("@/views/dashboard/layout-new/layout.vue"),
			children: [
				{
					// 首页
					name: "home",
					path: "/dashboard/home",
					component: () =>
						import("@/views/dashboard/home/index_v1.vue"),
				},
				{
					// 设备详情
					name: "device-detail",
					path: "/dashboard/device/:id",
					component: () =>
						import("@/views/dashboard/device-new/index.vue"),
				},
			],
		},
		{
			path: "/login",
			component: () => import("@/views/login/login.vue"),
		},
		{
			// 报修申请
			path: "/repair/apply",
			component: () => import("@/views/repair/Apply"),
		},
		{
			// 报修表单
			path: "/repair/apply/form",
			component: () => import("@/views/repair/ApplyForm"),
		},
	],
});

let routerPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(err => err)
}
export default router
